import required from "vuelidate/lib/validators/required";
import isValidTelephone from "@utils/is-valid-telephone";

import FieldText from "@components/molecules/m-field-text.vue";

export default {
  component: FieldText,
  attrs: {
    label: "Celular com DDD",
    name: "telefone",
    class: ["telefone"],
    placeholder: "Seu celular com DDD",
    type: "tel",
    mask: ["(##) #####-####"],
    required: true,
    // value: "",
    value: "",
  },
  errorMessages: [
    {
      name: "required",
      message: "O campo telefone é obrigatório!",
    },
    {
      name: "isValidTelephone",
      message: "Telefone inválido",
    },
  ],
  validation: {
    required,
    isValidTelephone,
  },
};
